<template>
  <div id="app">
    <Navbar ref="navbarRef" @changeConnect="handleIsConnected" v-show="$store.state.showNavbar"/>
    <router-view/>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
  export default {
    name: 'App',
    components: {
      Navbar
    },
    data() {
      return {
      }
    },
    created() {
      //清除token  不要自动登录
      this.$i18n.locale = localStorage.getItem('lang') || 'en'
      localStorage.clear()
      localStorage.setItem('lang', this.$i18n.locale)
      this.$router.replace({path: ''})
      this.$post('/user/num_map',{
        lang:"all",
        num:0
      }).then(res => {
        if(res.code==0){
          localStorage.setItem("errorDist",JSON.stringify(res.data))
        }
      })
      this.$post('/user/num_map',{
        lang:"all",
        num:2
      }).then(res => {
        if(res.code==0){
          localStorage.setItem("businessDist",JSON.stringify(res.data))
        }
      })
      this.$post('/user/num_map',{
        lang:"all",
        num:3
      }).then(res => {
        if(res.code==0){
          localStorage.setItem("typeDist",JSON.stringify(res.data))
        }
      })
    },
    mounted() {
      if (window.innerWidth > 750) {
        document.documentElement.style.fontSize = '40px'
      }
    },
    methods: {
      connectWallet() {
        this.$refs.navbarRef.connectWallet()
      },
      
    handleIsConnected(isConnected,send){
      if(!isConnected||!send) {
        this.$store.state.totalData = {
          total_out_usdt: '0',
          total_out_eqx: '0',
          sum_tusd: '0'
        }
        return
      }
      this.$post('/amount/total_out').then(res => {
        if (res.code === 0) {
          this.$store.state.totalData = res.data
        }else{
          const errorMessage = this.$getMsg(res.code)
          this.$message({
            message: errorMessage,
            type: 'error'
          })
        }
      })
    },
    }
  }

</script>

<style>
body{
  margin: 0;
  background-color: #000;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
@media (min-width: 768px) {
  #app{
    max-width: 375px;
    margin: 0 auto;
  }
  .navbar,.sub-navbar{
    max-width: 375px;
    left: 50% !important;
    transform: translateX(-50%);
  }
  .el-slider__button-wrapper{
    top: -16px !important;
  }
}
</style>
